export const primaryNavItems = [
    { title: "A Model to Remember", url: "/#ModelToRemember" },
    { title: "How it Worked", url: "/#ForTeens" },
    { title: "The Origin Story", url: "/#TheFoundation" }
];
